
<button on:click type="button" class="button is-light">
    <span class="icon"><i class="fas fa-ban"></i></span>
    <span>Cancelar</span>
</button>